import { render, staticRenderFns } from "./oneProject.vue?vue&type=template&id=61efe4fa&"
import script from "./oneProject.vue?vue&type=script&lang=js&"
export * from "./oneProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports